import React from 'react';
import './Dashboard.scss';

export default function Dashboard() {
    return(
        <div className='Dashboard' />
    )
}